import { ErrorMessages } from '../common/const';

/**
 * @validation
 */
export const initValidation = () => {
    // Правила валидации
    let rules = {
        messages: {
            required: ErrorMessages.REQUIRED,
            email: ErrorMessages.EMAIL,
            equalTo: ErrorMessages.PASSWORD_MATCH,
        }
    };

    $.validator.addMethod(`telInputMaskValidation`, function(value, element) {
        return this.optional(element) || (value.indexOf(`_`) == -1);
    }, ErrorMessages.TEL_COMPLETE);

    const requiredRules = Object.assign({
        required: {
            depends:function(){
                this.value = this.value.trimStart();
                return true;
            }
        },
    }, rules);

    $.validator.addMethod(`fileSizeValidation`, function(value, element) {
        const files = element.files;
        const maxSize = parseInt(element.getAttribute(`data-size`), 10);
        if (!files || files.length <= 0) return true;
        if (this.optional(element)) return true;
        for (let file of files) {
            return file.size <= maxSize;
        }
    }, ErrorMessages.FILE_MAX_SIZE);

    $.validator.addMethod(`fileFormatValidation`, function(value, element) {
        const files = element.files;
        // ".jpg, .jpeg, .png" => jpg|jpeg|png
        const accepted = $(element).attr('accept').replace('/[ .]/g', '').replace(',','|');
        let acceptedRegExp = new RegExp(accepted);
        if (!files || files.length <= 0) return true;
        if (this.optional(element)) return true;
        for (let file of files) {
            return file.type.match(acceptedRegExp);
        }
    }, ErrorMessages.FILE_TYPE);

    $.validator.addMethod(`lettersValidation`, function(value, element) {
        if (!value) return true;
        return this.optional(element) || !/[^a-zA-Zа-яА-Я ]/ui.test(value);
    }, ErrorMessages.LETTERS_ONLY);

    $.validator.addMethod(`checkboxValidation`, function(value, element) {
        if (!value) return false;
        return element.checked;
    }, ErrorMessages.CHECKBOX_REQUIRED);


    const mailRules = Object.assign({ email: true }, rules);
    // const mailStrictRules = Object.assign({ mailStrictValidation: true }, rules);
    const telRules = Object.assign({ telInputMaskValidation: true }, rules);
    const fileTypeRules = { fileFormatValidation: true };
    const fileSizeRules = { fileSizeValidation: true };
    const lettersOnlyRules = { lettersValidation: true };
    const checkboxRules = { checkboxValidation: true };

    // Элемент ошибки
    let validateObj = {
        errorElement: `span`,
        errorClass: `form-error f-body-s`,
        validClass: `success`,
        onkeyup: false,
        onclick: false,
        onfocusout: false,
        errorPlacement: function ($error, $element) {
            $element.closest(`[data-validation-input]`).append($error);
        },
        highlight(element, errorClass, validClass) {
            $(element).closest(`[data-validation-input]`).addClass(errorClass).removeClass(validClass);
        },
        unhighlight(element, errorClass, validClass) {
            $(element).closest(`[data-validation-input]`).removeClass(errorClass).addClass(validClass);
        }
    }

    // Валидируемые формы
    const $forms = $(`[data-validation-form]`);
    $forms.each((i, form) => $(form).validate(validateObj));

    $(`[data-validation-form] input, [data-validation-form] textarea`).each(function(i, el) {
        if (el.hasAttribute(`data-required`)) {
            $(el).rules(`add`, requiredRules);
        }

        if (el.hasAttribute(`data-validation-rules`)) {
            let validationRules = $(el).data('validation-rules').split(' ');

            validationRules.forEach(rule => {
                switch (rule) {
                    case `letters-only`:
                        $(el).rules(`add`, lettersOnlyRules);
                        break;
                    case `file-size`:
                        $(el).rules(`add`, fileSizeRules);
                        break;
                    case `file-type`:
                        $(el).rules(`add`, fileTypeRules);
                        break;
                    case `need-checked`:
                        $(el).rules(`add`, checkboxRules);
                        break;
                    case `password-match`:
                        $(el).rules(`add`, {
                            equalTo: $($(el).closest(`[data-validation-form]`).find(`input[type="password"]`)[0]),
                        });
                        break;
                    default:
                        break;
                }
            });
        }

        switch (el.type) {
            case `email`:
                $(el).rules(`add`, mailRules);
                break;
            case `tel`:
                $(el).rules(`add`, telRules);
                break;
            default:
                $(el).rules(`add`, rules);
                break;
        }
    });

    // Проверить валидность форм
    const checkValid = function(e) {
        const $target = $(e.target);

        if (!$target.valid() || $target.validate().errorList.length) {
            e.preventDefault();
            e.stopPropagation();
            $target.valid();
        } else {
            $target.parent().addClass(`sent`);
        }
    }

    // События отправки формы
    $forms.each((i, form) => {
        $(form).on(`submit`, checkValid);
    });

    // Inputmask
    $(`input[type="tel"]`).inputmask({
        mask: `+7 (999) 999-99-99`,
        clearMaskOnLostFocus: true,
        showMaskOnHover: false,
    });

    $(`input[type="email"]`).inputmask(`email`);

    // Autosize textarea on text input
    window.autosize($(`textarea`));
};
